/**
 * Pump Command Center — hero header and KPI strip.
 */
import { Link } from 'react-router-dom';
import { formatInrAmount, formatIndianNumber } from '../../../utils/reportFormat';

function healthTone(score) {
  if (score >= 75) return 'ok';
  if (score >= 50) return 'warn';
  return 'bad';
}

function formatInr(value) {
  return formatInrAmount(value);
}

export default function AdminPumpHubHeader({
  pump,
  analyticsSummary = {},
  analyticsSummaryLoading = false,
  billing = {},
  userCount = 0,
  alertCount = 0,
  onOpenReports,
}) {
  const score = analyticsSummary.overall_health_score;
  const scoreLoaded = analyticsSummary.loaded === true && score != null;
  const tone = healthTone(scoreLoaded ? score : 0);

  return (
    <>
      <div className="admin-pump-hub__hero">
        <Link to="/admin_dashboard" className="admin-pump-hub__hero-back">
          ← Back to Control Center
        </Link>
        <h1 className="admin-pump-hub__hero-title">{pump.pump_name}</h1>
        <p className="admin-pump-hub__hero-meta">
          {pump.pump_email}
          {' · '}
          {pump.pump_phone}
          {pump.confg_date ? ` · Live since ${pump.confg_date}` : ''}
        </p>
        <div className="admin-pump-hub__hero-actions">
          <button type="button" className="btn btn-light btn-sm" onClick={onOpenReports}>
            Open Owner Dashboard
          </button>
        </div>
      </div>

      <div className="admin-pump-hub__kpi-row">
        <div className="admin-pump-hub__kpi">
          <div className="admin-pump-hub__kpi-label">Business health</div>
          <div className={`admin-pump-hub__kpi-value admin-pump-hub__kpi-value--${tone}`}>
            {scoreLoaded ? formatIndianNumber(score, 2) : '—'}
          </div>
          <div className="admin-pump-hub__kpi-sub">
            {analyticsSummaryLoading
              ? 'Calculating…'
              : scoreLoaded
                ? (analyticsSummary.health_label || 'Health score')
                : 'Select a report period'}
          </div>
        </div>
        <div className="admin-pump-hub__kpi">
          <div className="admin-pump-hub__kpi-label">Total received</div>
          <div className="admin-pump-hub__kpi-value admin-pump-hub__kpi-value--ok">
            {formatInr(billing.total_received)}
          </div>
          <div className="admin-pump-hub__kpi-sub">Subscription payments</div>
        </div>
        <div className="admin-pump-hub__kpi">
          <div className="admin-pump-hub__kpi-label">Payment due</div>
          <div className={`admin-pump-hub__kpi-value ${Number(billing.payment_due) > 0 ? 'admin-pump-hub__kpi-value--bad' : ''}`}>
            {formatInr(billing.payment_due)}
          </div>
          <div className="admin-pump-hub__kpi-sub">Outstanding balance</div>
        </div>
        <div className="admin-pump-hub__kpi">
          <div className="admin-pump-hub__kpi-label">Pump users</div>
          <div className="admin-pump-hub__kpi-value admin-pump-hub__kpi-value--primary">{userCount}</div>
          <div className="admin-pump-hub__kpi-sub">Active accounts</div>
        </div>
        <div className="admin-pump-hub__kpi">
          <div className="admin-pump-hub__kpi-label">Open alerts</div>
          <div className={`admin-pump-hub__kpi-value ${alertCount > 0 ? 'admin-pump-hub__kpi-value--warn' : ''}`}>
            {alertCount}
          </div>
          <div className="admin-pump-hub__kpi-sub">Needs attention</div>
        </div>
      </div>
    </>
  );
}

export { healthTone, formatInr };
